/**
 * @desc 商户查询
 * @created: 2020/4/8
 * @author:lijun
 * @version : v1.0
 */

import request from '@/plugins/http'
import qs from 'qs'

// 列表
export const merchantList = params => {
  return request.get('/merchant/card/list', params)
}

// 商户端的收单机构列表
export const getMerchantAcquirerList = params => {
  return request.get('/company/list', params)
}

// 渠道列表
export const getChannelList = params => {
  return request.get('/servicer/save', params)
}

// 获取地区和地区码
export const getAreaList = params => {
  return request.get('/merchant/entry/area', params)
}

// 冻结 解冻
export const serverState = data => {
  return request.put('/servicer/state', qs.stringify(data))
}

// 获取商户下的支付终端信息
export const getPosAndSimCard = params => {
  return request.get('/merchant/card/queryPosAndSim', params)
}

// 获取商户的归属情况
export const getMerchantOwner = params => {
  return request.get('/merchant/card/listMerchantOwnership', params)
}

// 系统审批信息
export const getMerchantApply = params => {
  return request.get('/badRecord/getMerchantApply', params)
}

// 渠道审核信息
export const getChannelApplyInfo = params => {
  return request.get('/merchant/card/getChannelApplyInfo', params)
}

// 获取用户状态
export const getCardState = params => {
  return request.get('/badRecord/getCardState', params)
}

// 更新商户的sim和pos(支付终端信息)
export const updatePosAndSim = data => {
  return request.post('/merchant/card/updateOrAddPosAndSim', data, { json: true })
}

// 商户转移归属人员
export const transferOwnership = data => {
  return request.post('/merchant/card/transferMerchantOwnership', data, { json: true })
}

// 获取额度使用情况
export const getQuotaUsage = params => {
  return request.get('/merchant/card/getBalance', params)
}

// 通道更换历史
export const getChangehistory = params => {
  return request.get('/merchant/card/listModifyPayChannelHistory', params)
}

// 获取所有通道列表
export const getPaymentChannel = params => {
  return request.get('/merchant/card/paychannels', params)
}

// 更新商户支付终端信息
export const updateUnionPayment = data => {
  return request.post('/merchant/card/updateUnionPayment', qs.stringify(data))
}

// 可选通道列表
export const paychannels = params => {
  return request.get('/merchant/card/paychannels', params)
}

// 批量上送通道
export const goChannel = data => {
  return request.post('/merchant/card/goChannelBatch', data, { json: true })
}

// 归属转移 
export const transferMerchantOwnership = data => {
  return request.post('/merchant/card/transferMerchantOwnership', data, { json: true })
}

// 解冻商户 
export const unfreeze = data => {
  return request.post('/merchant/card/unfreeze', qs.stringify(data))
}


// 冻结商户 
export const freeze = data => {
  return request.post('/merchant/card/freeze', qs.stringify(data))
}

// 合同
export const getMerLookContract = params => {
  return request.get('/merchant/card/merLookContract', params)
}

// 商户-签章
export const againContract = params => {
  return request.get('/merchant/entry/againContract', params)
}

